import { cn } from '@/lib/utils'

/** Standard page gutters and compact top spacing; width overrides stay local. */
export function PageContainer({ children, className, ...props }) {
  return (
    <div
      data-slot="page-container"
      className={cn('mx-auto w-full max-w-page px-4 pb-8 pt-5 md:px-8 md:pt-6', className)}
      {...props}
    >
      {children}
    </div>
  )
}
